import { useEffect, useState } from "react";

export function QuickAccountForm({
  busy,
  error,
  submitLabel = "Create account",
  initialValues,
  onSubmit,
}: {
  busy?: boolean;
  error?: string | null;
  submitLabel?: string;
  initialValues?: { name?: string; domain?: string; website?: string; secondaryWebsite?: string };
  onSubmit: (values: { name: string; domain: string; website: string; secondaryWebsite: string }) => void;
}) {
  const [name, setName] = useState(initialValues?.name ?? "");
  const [domain, setDomain] = useState(initialValues?.domain ?? "");
  const [website, setWebsite] = useState(initialValues?.website ?? "");
  const [secondaryWebsite, setSecondaryWebsite] = useState(initialValues?.secondaryWebsite ?? "");

  useEffect(() => {
    setName(initialValues?.name ?? "");
    setDomain(initialValues?.domain ?? "");
    setWebsite(initialValues?.website ?? "");
    setSecondaryWebsite(initialValues?.secondaryWebsite ?? "");
  }, [initialValues?.name, initialValues?.domain, initialValues?.website, initialValues?.secondaryWebsite]);

  return (
    <form
      className="quick-account-form contact-form-grid"
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit({ name, domain, website, secondaryWebsite });
      }}
    >
      <label>
        <span className="contact-kv">Name</span>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Company name"
          required
          autoFocus
        />
      </label>
      <label>
        <span className="contact-kv">Domain</span>
        <input
          value={domain}
          onChange={(e) => setDomain(e.target.value)}
          placeholder="example.com"
          autoComplete="off"
        />
      </label>
      <label>
        <span className="contact-kv">Website</span>
        <input
          value={website}
          onChange={(e) => setWebsite(e.target.value)}
          placeholder="https://…"
          autoComplete="off"
        />
      </label>
      <label>
        <span className="contact-kv">Secondary website</span>
        <input
          value={secondaryWebsite}
          onChange={(e) => setSecondaryWebsite(e.target.value)}
          placeholder="https://…"
          autoComplete="off"
        />
      </label>
      {error ? <p className="err">{error}</p> : null}
      <div className="actions">
        <button type="submit" className="secondary" disabled={busy || !name.trim()}>
          {busy ? "Creating…" : submitLabel}
        </button>
      </div>
    </form>
  );
}
